import script from "./CobranzaMetricsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaMetricsRow.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaMetricsRow.vue?vue&type=style&index=0&id=2d7c4aa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7c4aa5"]])

export default __exports__